import { produce } from 'immer';
import * as types from './constants';

// initial state
export const initialState = {
  messages: [],
  alerts: [],
  loading: false,
  error: null,
};

/* eslint-disable default-case, no-param-reassign */
const messagesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.GET_MESSAGES:
        draft.loading = true;
        draft.messages = action.messages;
        break;
      case types.GET_ALERTS:
        draft.loading = true;
        draft.alerts = action.alerts;
        break;
      case types.GET_MESSAGES_CLEANUP:
        draft.loading = false;
        draft.error = null;
        draft.messages = [];
        break;
    }
  });

export default messagesReducer;
